import React from "react";
import { Card, FormCheck, FormControl } from "react-bootstrap";
import ConfirmDelete from "./ConfirmDelete";

interface IConfCampoDataProps {
  titulo: string;
  obrigatorio: boolean;

  onTitleChange: (titulo: string) => void;
  onDelete: () => void;
  onRequiredChange: (required: boolean) => void;
}

export function ConfCampoData({
  titulo,
  obrigatorio,
  onTitleChange,
  onRequiredChange,
  onDelete,
}: IConfCampoDataProps) {
  return (
    <Card>
      <Card.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Card.Title>Campo Data</Card.Title>
        <ConfirmDelete onDelete={onDelete} />
      </Card.Header>

      <Card.Body>
        <div className="mb-3">
          <label>Título</label>

          <FormControl
            type="text"
            value={titulo}
            onChange={(e) => onTitleChange(e.target.value)}
          />
        </div>

        <FormCheck
          type="checkbox"
          label="Obrigatório"
          checked={obrigatorio}
          onChange={(e) => onRequiredChange(e.target.checked)}
        />
      </Card.Body>
    </Card>
  );
}
